export default __webpack_public_path__ + "static/media/rapidresponse.5d6f4467.png";